export const staticData = {
  urgency: ['Critical', 'Non Critical'],
  typeOfGoods: ['Finished Goods', 'Road Tanker'],
  typeOfSku: ['Filling', 'Repack', 'Road Tanker'],
  typeOfFlow: ['Domestic', 'ICO'],
  typeOfRequest: [
    { label: 'Costing', value: 'Costing' },
    { label: 'Transfer Pricing', value: 'Transfer Pricing' },
    { label: 'Both', value: 'Both' },
  ],
  orderType: ['ZNB - Normal Flow', 'ZRB - Return Flow'],
};

export const titleTypeMap = {
  'Select Production Details': 'producing_plant_data',
  'Select Selling Plant': 'selling_plant_data',
  'Select Buying Details': 'buying_plant_data',
};
